import { render, staticRenderFns } from "./RxPassword.vue?vue&type=template&id=2194a742"
import script from "./RxPassword.vue?vue&type=script&lang=js"
export * from "./RxPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports